import type { Resolver } from 'cpool-schemas';
import { z } from 'zod';

import { DivisionsTableDefinitionZod } from '../../division/tables';
import { CorporationsTableDefinitionZod } from '../tables';

type Arguments = {
    position?: number;
    directorId: string;
};

export const schemaCorporationResolver_GetCorporationByDirectorId = CorporationsTableDefinitionZod.extend({
    divisions: z.array(DivisionsTableDefinitionZod),
});

export type SchemaCorporationResolver_GetCorporationByDirectorId = z.infer<
    typeof schemaCorporationResolver_GetCorporationByDirectorId
>;

export type CorporationResolver_GetCorporationByDirectorId = Resolver<
    Arguments,
    SchemaCorporationResolver_GetCorporationByDirectorId
>;
